// extracted by mini-css-extract-plugin
module.exports = {"header":"editorialList_header__oZVfU","container":"editorialList_container__o_S42"};